import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { loadRuntimeConfig } from "./config";
import { App } from "./App";
import "./styles.css";

async function bootstrap() {
  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("The application root element is missing.");

  const root = createRoot(rootElement);
  const config = await loadRuntimeConfig();

  if (config.demoMode) {
    root.render(
      <StrictMode>
        <App config={config} msal={null} />
      </StrictMode>,
    );
    return;
  }

  const msal = new PublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: `https://login.microsoftonline.com/${config.tenantId}`,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: { cacheLocation: "sessionStorage" },
  });
  await msal.initialize();
  const redirectResult = await msal.handleRedirectPromise();
  if (redirectResult?.account) msal.setActiveAccount(redirectResult.account);
  if (!msal.getActiveAccount() && msal.getAllAccounts()[0]) msal.setActiveAccount(msal.getAllAccounts()[0]!);

  root.render(
    <StrictMode>
      <MsalProvider instance={msal}>
        <App config={config} msal={msal} />
      </MsalProvider>
    </StrictMode>,
  );
}

void bootstrap().catch((error: unknown) => {
  console.error("Access Hub failed to start", error);
  const rootElement = document.getElementById("root");
  if (rootElement) rootElement.textContent = "Access Hub could not start. Please refresh or contact IT support.";
});
